const checkIsOpenAccount = subtype => {
    return subtype !== 'payroll-account' && subtype !== 'CUENTA NÓMINA OPEN';
}

const getAccountNameProduct = (subtype) => {
    return checkIsOpenAccount(subtype) ? 'adjuntar documentacion cuenta corriente open' : 'adjuntar documentacion cuenta corriente nómina';
}

const getAccountPath = (subtype) => {
    return checkIsOpenAccount(subtype) ? '/adjuntar-documentacion/cuenta-corriente' : '/adjuntar-documentacion/cuenta-nomina';
}

const getAccountNameText = (subtype) => {
    return checkIsOpenAccount(subtype) ? 'CUENTA CORRIENTE OPEN' : 'CUENTA NÓMINA OPEN';
}

module.exports = {
    getAccountNameProduct,
    getAccountNameText,
    getAccountPath,
} 